import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, Building2, Users, Clock, ArrowRight } from 'lucide-react';
import culture1 from '../assets/images/culture1.jpg'
import culture2 from '../assets/images/culture2.jpg'
const jobListings = [
  
];



const CareersPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-black to-gray-400 py-20 px-4">
  {/* Background Video */}
  <video
    src="https://www.shutterstock.com/shutterstock/videos/3536066183/preview/stock-footage-diverse-professionals-working-on-business-statistics-and-marketing-plans-in-corporate-office-top.webm"
    autoPlay
    loop
    muted
    playsInline
    className="absolute inset-0 w-full h-full object-cover z-0"
  />
  
  {/* Overlay */}
  <div className="absolute inset-0 bg-black/50 z-10" />

  {/* Content */}
  <div className="relative max-w-7xl mx-auto text-center z-20">
    <motion.h1
      className="text-4xl md:text-6xl font-bold text-white mb-6"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      We Create. We innovate. We produce
    </motion.h1>
    <motion.p
      className="text-3xl text-white/90 mb-4 font-bold"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      #WEMAKEITHAPPEN
    </motion.p>
    <motion.p
      className="text-xl text-white/80 mb-12 max-w-3xl mx-auto"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.4 }}
    >
      At BPL, we believe in empowering your capabilities and unleashing your potential. Always!
    </motion.p>

    {/* Search Form */}
    <motion.div
      className="max-w-3xl mx-auto bg-white rounded-lg p-4 shadow-lg flex flex-col md:flex-row gap-4"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.4 }}
    >
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search positions..."
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <select
        value={selectedDepartment}
        onChange={(e) => setSelectedDepartment(e.target.value)}
        className="w-full md:w-[200px] py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">Department</option>
        <option value="engineering">Engineering</option>
        <option value="design">Design</option>
        <option value="marketing">Marketing</option>
        <option value="sales">Sales</option>
      </select>
      <button className="w-full md:w-auto px-6 py-2 bg-orange-700 text-white rounded-md hover:bg-orange-700 transition-colors">
        Search Jobs
      </button>
    </motion.div>
  </div>
</section>


      {/* Open Positions */}
      {/* <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.h2 
            className="text-3xl font-bold text-center mb-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            Open Positions
          </motion.h2>
         <center><p>None</p></center> 
          <motion.div 
            className="grid gap-6 md:grid-cols-2 lg:grid-cols-3"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {jobListings.map((job) => (
              <motion.div
                key={job.id}
                variants={itemVariants}
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold mb-2">{job.title}</h3>
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-gray-600">
                    <Building2 className="h-4 w-4 mr-2" />
                    <span>{job.department}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <MapPin className="h-4 w-4 mr-2" />
                    <span>{job.location}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <Clock className="h-4 w-4 mr-2" />
                    <span>{job.type}</span>
                  </div>
                </div>
                <p className="text-gray-600 mb-4">{job.description}</p>
                <button className="w-full group flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md hover:border-blue-500 hover:text-blue-500 transition-colors">
                  Learn More
                  <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </button>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* Benefits Section */}
      {/* <section className="py-20 px-4 bg-gray-100">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4">Why Join Us?</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We offer competitive compensation and a comprehensive benefits package designed to support your well-being and growth.
            </p>
          </motion.div>

          <motion.div 
            className="grid gap-8 md:grid-cols-2 lg:grid-cols-4"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="bg-white rounded-lg p-6 text-center"
              >
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* Culture Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="grid md:grid-cols-2 gap-12 items-center"
          >
            <div>
              <h2 className="text-3xl font-bold mb-6">Our Culture</h2>
              <p className="text-gray-600 mb-6">
                We believe in fostering a culture of innovation, collaboration, and continuous learning. 
                Our team members are passionate about what they do and are committed to making a difference.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <Users className="h-6 w-6 mr-4 text-black" />
                  <div>
                    <h3 className="font-semibold mb-1">Collaborative Environment</h3>
                    <p className="text-gray-600">Work with talented individuals who share your passion.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Users className="h-6 w-6 mr-4 text-black" />
                  <div>
                    <h3 className="font-semibold mb-1">Growth Opportunities</h3>
                    <p className="text-gray-600">Clear career paths and mentorship programs.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Users className="h-6 w-6 mr-4 text-black" />
                  <div>
                    <h3 className="font-semibold mb-1">Work-Life Balance</h3>
                    <p className="text-gray-600">Flexible schedules.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src={culture2}
                alt="Team collaboration"
                className=" w-full h-full object-cover"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
              />
              <img
                src={culture1}
                alt="Office culture"
                className=" w-full h-full object-cover mt-8"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              />
            </div>
          </motion.div>
        </div>
      </section>

    
    </div>
  );
};

export default CareersPage;

